import {
  compose,
  lifecycle,
  withState,
  branch,
  renderNothing,
  withProps,
} from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { authorizeInstagram } from '../actions';

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      token: ownProps.location && ownProps.location.query.state,
      code: ownProps.location && ownProps.location.query.code,
      authorizeInstagram,
    }),
  ),
  withState('loading', 'setLoading', true),
  withState('confirm', 'setConfirm', false),
  withProps(props => ({
    canRender: props.token && props.code && !props.loading,
  })),
  lifecycle({
    componentDidMount() {
      this.props.authorizeInstagram(this.props.token, this.props.code)
        .then(() => {
          this.props.setLoading(false);
          this.props.setConfirm(true);

          if (window.opener && window.opener.location && window.opener.location.reload) {
            window.opener.location.reload();

            setTimeout(() => {
              window.close();
            }, 5000);
          }
        })
        .catch(() => {
          this.props.setLoading(false);
          this.props.setConfirm(false);
        });
    },
  }),
  branch(
    props => !props.canRender,
    renderNothing,
  ),
);
